import { z as zod } from 'zod';
import { createErrorMap } from 'zod-validation-error';

zod.config({
    customError: createErrorMap(),
});

export const JobApplyCodeSchema = zod.object({
    confirmCode: zod
        .string()
        .trim()
        .nonempty('validation.required.jobConfirmCode')
        .length(5, 'validation.range.jobConfirmCode')
        .refine((v) => /^\d+$/.test(v), {
            message: 'validation.onlyNumbers',
        }).
        transform(v=> Number)
});
